import { mapActions, mapGetters, mapState } from 'vuex'

export const SmartFormClickMixin = {
  computed: {
    ...mapState(['isUnitaryTest']),
    ...mapGetters(['isSinglePaymentButton', 'isSmartFormOpen'])
  },
  watch: {
    isSmartFormOpen(open) {
      if (open === false) {
        this.$emit('popin-close')
      } else {
        this.$emit('popin-open')
      }
    }
  },
  methods: {
    ...mapActions(['intercept', 'createApplePaySession']),
    async interruptsExecution(paymentMethod, action, formId = null) {
      try {
        // For Apple Pay, create the session initially. See KJS-3770
        if (paymentMethod === 'APPLE_PAY') this.createApplePaySession()
        // Intercept callback
        this.prepareFocusOnClosure()
        await this.intercept({
          name: 'onSmartFormClick',
          args: [{ paymentMethod, action, formId }]
        })
        return false
      } catch (e) {
        // Execution interrupted
        return true
      }
    },
    /**
     * Set the focus back to the payment button once popin is closed.
     *
     * @since KJS-3902
     */
    prepareFocusOnClosure() {
      this.$once('popin-open', () => {
        this.$once('popin-close', () => {
          if (typeof this.$el?.focus === 'function') this.$el.focus()
        })
      })
    }
  }
}
